module.exports = __webpack_public_path__ + "static/img/n1_3.8eaa713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n1_3.jpg
// module id = ixUq
// module chunks = 2